import { PageTitle, Tag } from '@stone-payments/jade';
import jadeTheme from '@stone-payments/jade-design-tokens/cjs/stone';
import styled from 'styled-components';

export const LinearBackgroundContainer = styled.div`
  min-height: 50%;
  background: linear-gradient(180deg, #F1F3F5 0%, rgba(255, 255, 255, 0) 38.86%);
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  min-height: 50%;
  display: flex;
  min-width: 350px;
  margin-bottom: -20px;
  justify-content: center;
  align-items: flex-end;
  z-index: 1;

  svg {
    object-fit: cover;
    height: auto;
 }
`;

export const ErrorCodeTag = styled(Tag)`
  margin-top: ${jadeTheme.global.space[500]};
`;

export const Title = styled(PageTitle)`
  margin-bottom: ${jadeTheme.global.space[150]};
`;

export const TextContainer = styled.div`
  margin-top: ${jadeTheme.global.space[300]};
  margin-bottom: ${jadeTheme.global.space[300]};
  width: 500px;

  .jade-box {
   margin: 0 auto;
   background-color: unset;
   border: none;
  }

  @media (max-width: 500px) {
    width: 100%;
  }
`;

export const Content = styled.div`
  max-width: 500px;
  justify-content: center;
  text-align: center;
`;

export const FlexBox = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;
